import Splide from "@splidejs/splide";
import { changeHistoryYearItalic } from "../utils/historyBlock/changeHistoryYearItalic.js";
import { createHistorySlides } from "../utils/historyBlock/createHistorySlides.js";
import { create } from "@splidejs/splide/src/js/utils";

const history = {
  2018: {
    photoCount: 1,
    text:
      "Мы уверены, что вам хорошо известны проблемы с сохранением исторического наследия в крупных и малых городах. Особенно остро эта проблема касается промышленного наследия в регионах. Причин появления заброшенных промышленных объектов много, однако мы хотим обратить внимание на другое: Разрушенные и полузаброшенные объекты притягивают туристов и, что самое важное, именно в том виде, в котором они дошли до нас сейчас.",
  },
  2019: {
    photoCount: 3,
    text:
      "Сохранение исторического наследия — острая проблема как для крупных, так и для малых городов. Особенно это касается промышленных зон, где заброшенные объекты становятся частью городской среды. Причины их запустения различны, но есть один важный аспект: такие места неизменно привлекают туристов, причем их уникальность заключается именно в том состоянии, в котором они сохранились до сегодняшнего дня. Их руины рассказывают истории прошлого, вызывая интерес и желание исследовать. ",
  },
  2020: {
    photoCount: 2,
    text:
      "Промышленное наследие как магнит для туристов Историческое наследие городов — это не только памятники архитектуры, но и заброшенные промышленные объекты, которые хранят следы ушедших эпох. В регионах проблема их сохранения стоит особенно остро, но именно их разрушенное состояние привлекает туристов, создавая уникальную атмосферу прошлого, застывшего во времени.",
  },
  2021: {
    photoCount: 3,
    text:
      "Заброшенные заводы: прошлое, которое притягивает Промышленные объекты, утратившие своё предназначение, продолжают оказывать влияние на городскую среду. Несмотря на их заброшенность, они притягивают внимание путешественников, создавая особый колорит и сохраняя память о бурном развитии индустрии.",
  },
  2022: {
    photoCount: 2,
    text:
      "Когда руины оживают: привлекательность промышленного наследия Города сталкиваются с проблемой сохранения своего исторического облика, особенно когда речь идёт о промышленных зонах. Разрушенные фабрики и заводы становятся точками притяжения, ведь их необработанная, аутентичная красота говорит сама за себя.",
  },
  2023: {
    photoCount: 2,
    text:
      "Сохранение прошлого через руины Вопрос сохранения промышленного наследия остаётся открытым, особенно в регионах. Однако именно эти полуразрушенные объекты вызывают интерес у туристов, поскольку несут в себе настоящую атмосферу прошлого, сохраняя его первозданный облик.",
  },
  2024: {
    photoCount: 1,
    text:
      "Промышленное наследие как история, застывшая во времени Многие города сталкиваются с проблемой сохранения заброшенных промышленных зон. Хотя их состояние может казаться упадком, оно несёт особую ценность, привлекая туристов и рассказывая историю без слов — через стены, механизмы и следы времени.",
  },
  2025: {
    photoCount: 1,
    text:
      "Индустриальные руины: туристическая привлекательность прошлого Старые заводы и фабрики — это не просто пережитки ушедшей эпохи, но и уникальные объекты, которые привлекают внимание туристов. Их полуразрушенный вид, следы времени и атмосфера запустения создают аутентичное восприятие индустриального прошлого, делая их ценными не только для исследователей, но и для любителей необычных маршрутов.",
  },
};
const historyBlock = document.querySelector(".about-history");

if (historyBlock) {
  let currentYear = 2019;

  document.addEventListener("DOMContentLoaded", function() {});

  const years = document.querySelector(".history__line");
  const historyYear = document.querySelector(".history__year");
  const historyText = document.querySelector(".history__infoText");
  const historySlidesList = document.querySelector(".splide__list");
  const historySlider = document.querySelector(".history__slider");

//   настройки слайдера
  const spliderSettings = {
      type: 'loop',
      heightRatio: 0.5,
      pagination: true,
      arrows: true,
      cover: true,
      breakpoints: {
          // 640: {
          //     heightRatio: 0.2,
          // },
      },
  }
  // загружаем слайды согласно установленному году
  historySlidesList.insertAdjacentHTML('beforeend', createHistorySlides(currentYear, history[currentYear].photoCount));
  let splide = new Splide(historySlider, spliderSettings).mount();
  
  

  years.addEventListener("click", (e) => {
    if (e.target.classList.contains("history__button")) {
        //уничтожаем существующий слайдер
        splide.destroy();

      // если нажали на кнопку - инициируем смену контента по году
      currentYear = e.target.textContent;
      changeHistoryYearItalic(currentYear, historyYear);
      // делаем наждатый год активным, предварительоно убираем у всех остальных активный класс
      years
        .querySelectorAll(".history__item--active")
        .forEach((el) => el.classList.remove("history__item--active"));
      e.target.closest(".history__item").classList.add("history__item--active");

      // -----------------------------------------------
        //   меняем текст у блока c информацией о годе
        historyText.textContent = history[currentYear].text;

      // -----------------------------------------------
        // генерируем слайды для текущего года

        console.log( createHistorySlides(currentYear, history[currentYear].photoCount))
        historySlidesList.textContent = "";
        historySlidesList.insertAdjacentHTML('beforeend', createHistorySlides(currentYear, history[currentYear].photoCount));

        splide = new Splide(historySlider, spliderSettings).mount();
    }
  });




}
